import { Rocket } from "lucide-react";
import { FibButton } from "./FibButton";
import { useMemo, memo } from "react";

interface Props {
  values: bigint[];
  selected: boolean[];
  onToggle: (i: number) => void;
  label: string;
  type: "ship" | "sheep";
}

export const FibSelector = memo(function FibSelector({ values, selected, onToggle, label, type }: Props) {
  const handlers = useMemo(
    () => values.map((_, i) => () => onToggle(i)),
    [values, onToggle]
  );

  return (
    <div className="fib-selector">
      <div className="fib-selector-label">
        {type === "ship" ? <Rocket size={14} /> : <span style={{ fontSize: 14 }}>🐑</span>}
        {label}
      </div>
      <div className="fib-list">
        {values.map((v, i) => (
          <FibButton
            key={i}
            value={v}
            selected={selected[i]}
            disabled={
              !selected[i] &&
              ((selected[i - 1] ?? false) || (selected[i + 1] ?? false))
            }
            onClick={handlers[i]}
            type={type}
          />
        ))}
      </div>
      <div className="selected-list">
        {selected.some(Boolean)
          ? "Wybrane: " + values.filter((_, i) => selected[i]).join(", ")
          : <span style={{ color: "var(--text-muted)" }}>– brak wyboru –</span>}
      </div>
    </div>
  );
});
